import { ROLE_LABELS_COPY } from "./roles.copy";
import type { RoleLabel } from "./roles.types";

/**
 * Papéis de vínculo com um espaço, como o token os carrega.
 *
 * Morava em `apps/web/src/services/user/types.ts` (41 importadores) e o mobile
 * repetia os literais (`"org:owner"`) onde precisava. Subiu com o esqueleto do
 * logado: o menu, o seletor de espaço e as seções de "Gerenciar espaço"
 * comparam papel, e as três plataformas precisam concordar no valor.
 */
/**
 * Papéis de um espaço. Os **valores** são persistidos (JWT, banco) e não
 * mudam. Objeto `as const` em vez de `enum` (regra do pacote); o tipo tem o
 * mesmo nome do objeto para que `role: ROLES` siga valendo em todo consumidor.
 */
export const ROLES = {
  OWNER: "org:owner",
  ADMIN: "org:admin",
  PLANNER: "org:planner",
  // FINANCIAL: "org:financial",
  COMMERCIAL: "org:commercial",
  COMMERCIAL_PLANNER: "org:commercial_planner",
} as const;
export type ROLES = (typeof ROLES)[keyof typeof ROLES];

/**
 * O nome que a pessoa vê para o papel dela. Papel desconhecido devolve o
 * próprio valor — melhor um `org:x` na tela do que texto vazio.
 */
export function roleTransform(role: ROLES): RoleLabel {
  const name = ROLE_LABELS_COPY[role];
  return { name: name ?? role, key: role };
}

/**
 * O papel que a pessoa vê para si mesma. Dono é "Creator Tãmi" mesmo sem
 * espaço ativo; membro precisa de espaço ativo para o subpapel valer; quem
 * não tem vínculo não tem papel (`null`).
 *
 * Era o corpo de `useRoleUserLogged` no web; o menu do app mostra a mesma
 * linha abaixo do nome.
 */
export function resolveUserRoleLabel(claims: {
  readonly orgId?: string | null;
  readonly orgRole?: string | null;
  readonly orgSubRole?: string | null;
}): RoleLabel | null {
  if (claims.orgRole === ROLES.OWNER) {
    return roleTransform(ROLES.OWNER);
  }
  if (claims.orgId && claims.orgSubRole) {
    return roleTransform(claims.orgSubRole as ROLES);
  }
  return null;
}
